export default {
    setHTMLTemplate(state, payload) {
        state.template_html = payload;
    },
    setHTMLtemplateLoaded(state, payload) {
        state.loaded = payload;
    },
};